import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { WarehouseProductType } from '../enums/warehouse-product-type';

@Injectable({
  providedIn: 'root',
})
export class WarehouseProductTypeProviderService {
  /* prettier-ignore */
  private entries = new Map<WarehouseProductType, string>([
    [WarehouseProductType.Accessories, 'Akcesoria, np. wstążka, bibułka'],
    [WarehouseProductType.Box, 'Pudełko na kosmetyki'],
    [WarehouseProductType.Cosmetic, 'Kosmetyk'],
    [WarehouseProductType.Product, 'Produkt'],
  ]);

  public label(type: WarehouseProductType): Observable<string> {
    const entry = this.entries.get(type);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${type}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<WarehouseProductType>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
